import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';

import AcademicPaperEditing from './blogs/Academic-paper-editing.js';
import EssayCorrectionsCanSaveYourGrade from './blogs/Essay-corrections-can-save-your-grade.js';
import EditingEssaysInEnglishIsntEasy from './blogs/Editing-essays-in-english-isnt-easy.js';
import EslEssayEditingHelp from './blogs/Esl-essay-editing-help.js';
import TheMostImportantGradeOfYourCollegeCareer from './blogs/The-most-important-grade-of-your-college-career.js';
import WeFixEssays from './blogs/We-fix-essays';
import WhatMakesAThesisDifferentThanEveryOtherEssay from './blogs/What-makes-a-thesis-different-than-every-other-essay.js';
import WhatsWrongWithProofreadingYourOwnEssays from './blogs/Whats-wrong-with-proofreading-your-own-essays.js';

const styles = {
    localH1: { 
        fontSize: '36px',
    },
    localH2: { 
        fontSize: '28px',
    },
    onlyParagraph: { 
        fontSize: '20px',
        lineHeight: '26px',
    },
    instructionList: { 
        paddingTop: '10px',
        listStyleType: 'disc',
    },
    instructionListItem: { 
        marginBottom: '15px',
    },
    question: { 
        fontSize: '24px',
        lineHeight: '26px',
        marginBottom: '10px',
    },
    answer: { 
        fontSize: '18px',
        lineHeight: '20px',
    }
}

const pieces = {
    'academic-paper-editing': AcademicPaperEditing,
    'essay-corrections-can-save-your-grade': EssayCorrectionsCanSaveYourGrade,
    'editing-essays-in-english-isnt-easy': EditingEssaysInEnglishIsntEasy,
    'esl-essay-editing-help': EslEssayEditingHelp,
    'the-most-important-grade-of-your-college-career': TheMostImportantGradeOfYourCollegeCareer,
    'we-fix-essays': WeFixEssays,
    'what-makes-a-thesis-different-than-every-other-essay': WhatMakesAThesisDifferentThanEveryOtherEssay,
    'whats-wrong-with-proofreading-your-own-essays': WhatsWrongWithProofreadingYourOwnEssays
}
class Blog extends Component{

    constructor(props) {
        super(props);
    }
    render() { 
        var title = "FAQ - Frequently Asked Questions | Edit My Paper";
        var description = "These frequently asked questions can assist you in addressing whether our proofreading service is right for you.";
        var keyword = "Edit,My,Paper,Editing,Examples,University,College,Students";
        var MYcomponent = null;
        var canonical = 'https://editmypaper.ca/blog';
        var links = [];
        for(var i in pieces) {
            var href = '/blog/' + i;
            links.push(<li><Link key={i} to={href}>{pieces[i].linkTitle}</Link></li>)
        }
        
        var foundPiece = null;
        if(this.props.match && this.props.match.params.piece) {
            foundPiece = this.props.match.params.piece;
        }
        if(foundPiece == null && this.props.piece) {
            foundPiece = this.props.piece;
        }
        if(foundPiece) {
            var piece = foundPiece;
            for(var i in pieces) {
                if(i == piece) {
                    MYcomponent = pieces[i];
                    title = MYcomponent.getTitle();
                    description = MYcomponent.getDescription();
                    keyword = MYcomponent.getKeyword();
                    canonical = 'https://editmypaper.ca/'+piece;
                }
            }
        }
        return (<div>
                    <Helmet>
                        <title>{title}</title>
                        <meta name="description" content={description}></meta>
                        <meta name="keywords" content={keyword}></meta>
                        <meta name="author" content="EditMyPaper.ca"></meta>
                        <link rel="canonical" href={canonical} />
                    </Helmet>
                    <TopNav />
                    <section className="steps top_section">
                        <div className="steps-container">
                        {(MYcomponent != null)?
                            <div><MYcomponent /></div>
                            :
                            <div>
                                <h1>Edit My Paper’s Blog</h1>
                                <ul>{links}</ul>
                            </div>
                        }
                        </div>
                    </section>
                    <Footer></Footer>
                </div>
        )
    }
}
export default connect(
)(Blog);



// WEBPACK FOOTER //
// ./src/components/pages/Blog.js